export default __webpack_public_path__ + "static/media/sistemasderega.368ac105.svg";